import { ApiResult } from "common/models";
import {
  CombineUsedProfile,
  GraphUserProfile,
  UserSession
} from "common/models/user-details.model";
import { put, takeLatest } from "redux-saga/effects";
import { UserService } from "../user.service";
import { userActions } from "../user.slice";

/**
 *
 * getUserProfile
 */
const getUserProfile = function* () {
  const { hasErrors, value }: ApiResult<GraphUserProfile> =
    yield UserService.getUserProfile();

  const {
    hasErrors: hasAppUserError,
    value: appUserVal,
    statusCode
  }: ApiResult<UserSession> = yield UserService.getAppUserProfile();

  if (hasErrors || hasAppUserError || statusCode === 403) {
    yield put({
      type: userActions.getUserProfileError.type
    });
  } else {
    const combinedProfile: CombineUsedProfile = {
      ...value!,
      userRole: appUserVal.userRoles
    };

    yield put({
      type: userActions.getUserProfileSuccess.type,
      payload: combinedProfile
    });
  }

  //   const {
  //     hasErrors: hasAppUserError,
  //     value: appUserVal
  //   }: ApiResult<ApplicationUserProfile> = yield UserService.getAppUserProfile();
  //   if (hasErrors || hasAppUserError) {
  //     yield put({
  //       type: userActions.getUserProfileError.type
  //     });
  //   } else {
  //     const combinedProfile: CombineUsedProfile = {
  //       ...value!,
  //       userRole: appUserVal?.userRole || ""
  //     };

  //     yield put({
  //       type: userActions.getUserProfileSuccess.type,
  //       payload: combinedProfile
  //     });
  //   }
};

const getUserProfileWatch = function* () {
  yield takeLatest(userActions.getUserProfile.type, getUserProfile);
};

const logoutUserWatch = function* () {
  yield takeLatest(userActions.logoutUserBegin.type, logoutUser);
};

const logoutUser = function* () {
  const { hasErrors, errors, value }: ApiResult<undefined> =
    yield UserService.logoutUser();

  if (!hasErrors) {
    yield put({
      type: userActions.logoutUserSuccess.type
    });
  }
};

export { getUserProfileWatch, logoutUserWatch };
